import React from "react";
import { Button, Empty, Row } from "antd";
import { WarningTwoTone } from "@ant-design/icons";
import { useHistory } from "react-router-dom";

const NoPermissions = (): JSX.Element => {
  const history = useHistory();
  return (
    <Row
      style={{ width: "100%", height: "100%", padding: 30 }}
      justify="center"
      align="top"
    >
      <Empty
        description="Nie posiadasz wystarczających uprawnień aby wyświetlić tę zawartość"
        image={<WarningTwoTone twoToneColor="#aaa" style={{ fontSize: 120 }} />}
        imageStyle={{ height: 140 }}
      >
        <Button type="primary" danger onClick={() => history.replace("/")}>
          Wróć na stronę główną
        </Button>
      </Empty>
    </Row>
  );
};

export default NoPermissions;
